import {
  BlocksApi,
  type CreateMemberBlockRequest,
  type UpdateMemberBlockRequest,
  type MemberBlockResponse,
  type MemberBlockListResponse
} from 'we-tree-api-client/v2';

import { getApiConfiguration } from '@/services/SessionService';
import { ApiResult, withApiSetup } from './apiWrapper';

export type { CreateMemberBlockRequest, UpdateMemberBlockRequest, MemberBlockResponse, MemberBlockListResponse };

class WrappedMemberBlocksApi {
  async list(familyId: string, familyMemberId: string): Promise<ApiResult<MemberBlockListResponse>> {
    return withApiSetup(
      (config) => new BlocksApi(config),
      getApiConfiguration,
      (api) => api.getMemberBlocks(familyId, familyMemberId)
    );
  }

  async create(
    familyId: string,
    familyMemberId: string,
    request: CreateMemberBlockRequest
  ): Promise<ApiResult<MemberBlockResponse>> {
    return withApiSetup(
      (config) => new BlocksApi(config),
      getApiConfiguration,
      (api) => api.createMemberBlock(familyId, familyMemberId, request)
    );
  }

  async update(
    familyId: string,
    familyMemberId: string,
    userId: string,
    request: UpdateMemberBlockRequest
  ): Promise<ApiResult<MemberBlockResponse>> {
    return withApiSetup(
      (config) => new BlocksApi(config),
      getApiConfiguration,
      (api) => api.updateMemberBlock(familyId, familyMemberId, userId, request)
    );
  }

  async remove(familyId: string, familyMemberId: string, userId: string): Promise<ApiResult<void>> {
    return withApiSetup(
      (config) => new BlocksApi(config),
      getApiConfiguration,
      (api) => api.deleteMemberBlock(familyId, familyMemberId, userId)
    );
  }
}

export const memberBlocksApi = new WrappedMemberBlocksApi();
export default memberBlocksApi;
